import React from 'react';
import { RectifyRefundPaymentModeContextProvider } from './context';
import SelectPaymentModeWrapper from './SelectPaymentModeWrapper';
import { useWizard } from '../../../../../components/wizard/WizardContext';
import ProceedNextFooter from './ProceedNextFooter';

const SelectPaymentMode = () => {

    const { next, values } = useWizard();
    const { rectRefundStep2Data } = values;
    const { receiptsSelectionModel } = rectRefundStep2Data;

    return (
        <RectifyRefundPaymentModeContextProvider key={receiptsSelectionModel[0]}>

            <SelectPaymentModeWrapper module={"RectificationRefund"} />
            <ProceedNextFooter next={next} />

        </RectifyRefundPaymentModeContextProvider>
    );
}

export default SelectPaymentMode;